import { createStore } from 'vuex'

import moment from 'moment'

export default createStore({
  state: {
    lastUpdate: null,
    trends: null,
    windowWidth: window.innerWidth,
    place: null,
    notFound: false,
  },
  mutations: {
    setLastUpdate(state, lastUpdate) {
      state.lastUpdate = lastUpdate
    },
    setTrends(state, trends) {
      state.trends = trends
    },
    windowWidth(state, width) {
      state.windowWidth = width
    },
    setPlace(state, place) {
      state.place = place
    },
    setNotFound(state, notFound) {
      state.notFound = notFound
    },
  },
  actions: {
    async loadData({commit}, place_code) {
      let response
      let json

      response = await fetch('/latests/' + place_code)
      json = await response.json()
      let place = json.latest
      let lastUpdate = json.lastUpdate

      if (!place) {
        commit('setNotFound', true)
        return null
      }

      response = await fetch('/trends/' + place_code)
      json = await response.json()
      let trends = json.trends

      if (0 >= trends.length) {
        commit('setNotFound', true)
        return null
      }

      commit('setTrends', trends)
      commit('setLastUpdate', lastUpdate)
      commit('setPlace', place)

      return place
    },
  },
  modules: {
  },
  getters: {
    isPC(state) {
      return 480 <= state.windowWidth
    },
    isSP(state) {
      return 480 > state.windowWidth
    },
    lastUpdateDateTime(state) {
      return state.lastUpdate ? moment(state.lastUpdate).utcOffset('+0900').format("YYYY/MM/DD HH:mm") : null
    },
  },
})
